export default function ReadOnlyNote({ text = "Tu rol solo tiene acceso de lectura aquí" }) {
  return (
    <span className="crud-readonly-note">
      <i className="bi bi-eye"></i> {text}
    </span>
  );
}
